import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

// =============================================================================
// Animation Field Icons
// =============================================================================

export function Zap(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "WebsiteZap",
    viewBox: "0 0 24 24",
    path: (
      <polygon
        points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon-outline"
      />
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function Play(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "WebsitePlay",
    viewBox: "0 0 24 24",
    path: (
      <polygon
        points="5 3 19 12 5 21 5 3"
        fill="currentColor"
        className="icon-primary"
      />
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function WebsiteClock(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "WebsiteClock",
    viewBox: "0 0 24 24",
    path: (
      <>
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <polyline
          points="12 6 12 12 16 14"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function TimingCurve(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "TimingCurve",
    viewBox: "0 0 24 24",
    path: (
      <polyline
        points="22 12 18 12 15 21 9 3 6 12 2 12"
        stroke="currentColor"
        strokeWidth="2"
        className="icon-outline"
      />
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function Repeat(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "WebsiteRepeat",
    viewBox: "0 0 24 24",
    path: (
      <>
        <polyline
          points="17 1 21 5 17 9"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <path
          d="M3 11V9a4 4 0 0 1 4-4h14"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <polyline
          points="7 23 3 19 7 15"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <path
          d="M21 13v2a4 4 0 0 1-4 4H3"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}
